import { useMutation } from "@tanstack/react-query";
import { createNotification } from "../../../shared/store/notifications";
import _cookies from "../../../shared/utils/_cookies";
import { axios } from "../../../shared/lib/axios";
export const registerAttendance = async (data) => {
  const { classId } = data;
  const form = new FormData();

  form.append(
    "dados",
    `[${JSON.stringify({
      aulaid: classId,
      alunoid: _cookies.getItem("auth").user.alunoid,
    })}]`
  );
  const enrollmentRes = await axios.middleware.post(
    "/aluno.asmx/Verifica_matricula_aula",
    form,
    {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    }
  );

  const enrollmentData = res[0].data;
  const form2 = new FormData();
  form2.append(
    "dados",
    `[${JSON.stringify({
      alunoid: _cookies.getItem("auth").user.alunoid,
      aulaid: classId,
      ...data,
    })}]`
  );
  const res = await axios.middleware.post(
    "/aluno.asmx/Registra_presenca",
    form2,
    {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    }
  );
  return res;
};

export const useRegisterAttendance = ({ config } = {}) => {
  return useMutation({
    ...config,
    mutationFn: registerAttendance,
    onSuccess: () => {
      createNotification({
        type: "success",
        message: "Presença registrada com sucesso",
      });
    },
  });
};
